import StoreSettingsPage from './detail/StoreSettingsPage';
import WebhooksTab from './detail/WebhooksTab';

export default function StoreWebhooks() {
	return (
		<StoreSettingsPage title='Store - Webhooks'>
			{(store) => <WebhooksTab storeId={store.storeId} />}
		</StoreSettingsPage>
	);
}
